export enum UsersActionTypes {
  GET_LIST_USERS_SUCCESS = "USERS_GET_LIST_SUCCESS",
  GET_LIST_USERS_ERROR = "USERS_GET_LIST_ERROR",
  GET_LIST_USERS = "USERS_GET_LIST",
  CREATE_USER = "CREATE_USER",
  CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS",
  CREATE_USER_ERROR = "CREATE_USER_ERROR",
  GET_USER = "GET_USER",
  GET_USER_SUCCESS = "GET_USER_SUCCESS",
  GET_USER_ERROR = "GET_USER_ERROR",
  UPDATE_USER = "UPDATE_USER",
  UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS",
  UPDATE_USER_ERROR = "UPDATE_USER_ERROR",
  UPDATE_USER_PASSWORD = "UPDATE_USER_PASSWORD",
  UPDATE_USER_PASSWORD_SUCCESS = "UPDATE_USER_PASSWORD_SUCCESS",
  UPDATE_USER_PASSWORD_ERROR = "UPDATE_USER_PASSWORD_ERROR",
  UPDATE_USER_ACTIVATION = "UPDATE_USER_ACTIVATION",
  UPDATE_USER_ACTIVATION_SUCCESS = "UPDATE_USER_ACTIVATION_SUCCESS",
  UPDATE_USER_ACTIVATION_ERROR = "UPDATE_USER_ACTIVATION_ERROR",
  DELETE_USER = "DELETE_USER",
  DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS",
  DELETE_USER_ERROR = "DELETE_USER_ERROR",
  DOWNLOAD_USERS = "DOWNLOAD_USERS",
  DOWNLOAD_USERS_SUCCESS = "DOWNLOAD_USERS_SUCCESS",
  DOWNLOAD_USERS_ERROR = "DOWNLOAD_USERS_ERROR",
  UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE",
  UPDATE_USER_PROFILE_SUCCESS = "UPDATE_USER_PROFILE_SUCCESS",
  UPDATE_USER_PROFILE_ERROR = "UPDATE_USER_PROFILE_ERROR",
  GET_SELLER_LIST = "GET_SELLER_LIST",
  GET_SELLER_LIST_SUCCESS = "GET_SELLER_LIST_SUCCESS",
  GET_SELLER_LIST_ERROR = "GET_SELLER_LIST_ERROR",
  GET_AGENT_LIST = "GET_AGENT_LIST",
  GET_AGENT_LIST_SUCCESS = "GET_AGENT_LIST_SUCCESS",
  GET_AGENT_LIST_ERROR = "GET_AGENT_LIST_ERROR",
  GET_DELIVERY_LIST = "GET_DELIVERY_LIST",
  GET_DELIVERY_LIST_SUCCESS = "GET_DELIVERY_LIST_SUCCESS",
  GET_DELIVERY_LIST_ERROR = "GET_DELIVERY_LIST_ERROR",
}
